<template>
  <ModalDialog
    ref="dialog"
    title="Close Invoice"
    icon="fa-check-circle"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Close"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>This will manually close the invoice and mark it as paid</NotificationBarTitle>
        <ul>
          <li>This is a manual process to flag invoices as paid and close them off.</li>
          <li>Invoice allocations will <strong>NOT</strong> match the total invoice amount.</li>
          <li>The remaining amount due will be set to {{formatCurrency(0)}} and the invoice will no longer show up under amounts owing</li>
        </ul>

        <template v-if="hasXeroIntegration">
          <strong>Xero Users</strong>
          <ul>
            <li>After closing an invoice, please access Xero to ensure the invoice is manually closed too</li>
          </ul>
        </template>
      </NotificationBar>
      
      <FormRow label="Closing Reason">
        <FormInputTextArea ref="textEntryArea" v-model="closeReason" placeholder="Enter reason and details for closing the invoice" field="reason" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'CloseInvoiceDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    invoiceId: Number
  },
  data() {
    return {
      form: {},
      submitting: false,
      closeReason: ''
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()
      this.submitting = true

      var updateData = {
        reason: this.closeReason
      }

      this.$apiService.accountsService.closeInvoice(this.invoiceId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>